import styles from './Leaderboard.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import HoustonAd from 'HoustonAd/HoustonAd';

const mapStateToProps = ({ location }) => {
  return {
    locale: location.locale
  };
};

@connect(mapStateToProps)
export default class Leaderboard extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  render() {
    const { locale } = this.props;
    const leaderboardId = `/18718623/SEEK${locale}/jobsearch_leaderboard`;

    return (
      <div className={styles.root}>
        <HoustonAd
          tagId={leaderboardId}
          width={728}
          height={90}
        />
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/Leaderboard/Leaderboard.js
 **/